var OptionsDatasource_1;
import { __awaiter, __decorate } from "tslib";
import { ResourceType } from '@genesislcap/foundation-comms';
import { attr, customElement, DOM, observable } from '@microsoft/fast-element';
import { Combobox } from '../combobox';
import { BaseDatasource, logger } from '../utils';
import { dataserverCriteriaBuilder, requestServerCriteriaBuilder } from '../utils';
let OptionsDatasource = OptionsDatasource_1 = class OptionsDatasource extends BaseDatasource {
    constructor() {
        super(...arguments);
        this.initalSelectedValueInitialized = false;
        this.isSnapshot = true;
    }
    initialSelectedValueChanged(oldValue, newValue) {
        if (newValue)
            this.initalSelectedValueInitialized = false;
    }
    connectedCallback() {
        const _super = Object.create(null, {
            connectedCallback: { get: () => super.connectedCallback }
        });
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            _super.connectedCallback.call(this);
            this.fields = this.labelField ? (_a = this.valueField) === null || _a === void 0 ? void 0 : _a.concat(' ', this.labelField) : this.valueField;
            this.select = this.parentElement;
            this.select.addEventListener('change', (e) => {
                const selectedOption = this.options.find((option) => option.label === e.target.value);
                this.select.$emit('value-change', selectedOption);
            });
            if (this.select &&
                this.valueField &&
                ((this.resourceName && this.connect.isConnected) || this.data)) {
                if (this.select instanceof Combobox && this.select.async && this.initialSelectedValue) {
                    this.asyncModeIntialization();
                }
                else {
                    this.fetchGenesisData();
                }
            }
            if (!this.valueField) {
                logger.warn('Specify field for values in options (e.g value-field="VALUE") and optionally field for label (e.g label-field="NAME")');
            }
        });
    }
    asyncModeIntialization() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.datasource.init(this['datasourceOptions'](), true);
            const resourceType = this.datasource.resourceType;
            if (resourceType === ResourceType.DATASERVER) {
                dataserverCriteriaBuilder(this, this.initialSelectedValue);
            }
            if (resourceType === ResourceType.REQUEST_SERVER) {
                requestServerCriteriaBuilder(this, this.initialSelectedValue);
            }
        });
    }
    clearData() {
        Array.from(this.select.children).forEach((x) => {
            if (!(x instanceof OptionsDatasource_1)) {
                this.select.removeChild(x);
            }
        });
        this.select.value = '';
        this.select.initialValue = '';
    }
    syncComponentData(snapshotData) {
        var _a;
        const rowData = snapshotData !== null && snapshotData !== void 0 ? snapshotData : Array.from(this.rowsSyncedWithStream.values());
        this.options = rowData.map((row) => ({
            value: row[this.valueField],
            label: this.labelFormatter ? this.labelFormatter(row[this.labelField]) : row[this.labelField],
        }));
        const listboxOptions = this.options.map(({ value, label }) => {
            const option = document.createElement(this.optionElement);
            option.textContent = label ? label : value;
            option.value = value;
            return option;
        });
        listboxOptions.forEach((x) => {
            this.select.appendChild(x);
        });
        if (!this.initalSelectedValueInitialized) {
            const initialLabel = this.initialSelectedValue || this.initialSelectedValue === 0
                ? (_a = this.options.find((x) => x.value === this.initialSelectedValue)) === null || _a === void 0 ? void 0 : _a.label
                : '';
            DOM.queueUpdate(() => {
                this.select.value = initialLabel;
            });
            this.initalSelectedValueInitialized = true;
        }
    }
    handleStreamInserts(insertedRows) {
        logger.debug('handleStreamInserts - Method not implemented.');
    }
    handleStreamDeletes(deletedRows) {
        logger.debug('handleStreamDeletes - Method not implemented.');
    }
    handleStreamUpdates(updatedRows) {
        logger.debug('handleStreamUpdates - Method not implemented.');
    }
};
__decorate([
    attr({ attribute: 'label-field' })
], OptionsDatasource.prototype, "labelField", void 0);
__decorate([
    attr({ attribute: 'option-element' })
], OptionsDatasource.prototype, "optionElement", void 0);
__decorate([
    attr({ attribute: 'value-field' })
], OptionsDatasource.prototype, "valueField", void 0);
__decorate([
    observable
], OptionsDatasource.prototype, "labelFormatter", void 0);
__decorate([
    observable
], OptionsDatasource.prototype, "initialSelectedValue", void 0);
OptionsDatasource = OptionsDatasource_1 = __decorate([
    customElement({
        name: 'options-datasource',
    })
], OptionsDatasource);
export { OptionsDatasource };
